module.exports = `${require.publicPath}defaultAvatar.7b201d0c.jpg`;